import { render, staticRenderFns } from "./ImportHistoricModal.vue?vue&type=template&id=5aa5dcec"
import script from "./ImportHistoricModal.vue?vue&type=script&lang=js"
export * from "./ImportHistoricModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports